import { render, staticRenderFns } from "./TasksAndRequestsList.vue?vue&type=template&id=ba0b2046&scoped=true&"
import script from "./TasksAndRequestsList.vue?vue&type=script&lang=js&"
export * from "./TasksAndRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0b2046",
  null
  
)

export default component.exports